export default __webpack_public_path__ + "static/media/CSS-removebg-preview.97470a16.png";